module.exports = __webpack_public_path__ + "media/images/active_material/icons/more-e30ac9b7ada758893b35f35a72695ec1.svg";